import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useState, useEffect } from "react";
import { auth } from '../../../contexts/authentication';
import { UserData, getUser } from '../../../frontend/pages/getUserDB';
import { updateProfile } from 'firebase/auth';
import WarningAlert from '../WarningAlert';

interface ChangeNameProps {
  showNameModal: boolean;
  setShowNameModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowSuccessAlert: React.Dispatch<React.SetStateAction<boolean>>;
  setMessageAlert: React.Dispatch<React.SetStateAction<string>>;
}

export default function ChangeName({
  showNameModal,
  setShowNameModal,
  setShowSuccessAlert,
  setMessageAlert
}: ChangeNameProps) {
  const currentUser = auth.currentUser;
  const [userDB, setUserDB] = useState<UserData>();
  const [newName, setNewName] = useState<string>('');
  const [showWarningAlert, setShowWarningAlert] = useState(false);


  useEffect(() => {
    const dataUser = async () => {
      const data = await getUser();
      setUserDB(data);
    }
    dataUser();
  }, []);

  useEffect(() => {
    if (showWarningAlert) {
      setTimeout(() => {
        setShowWarningAlert(false)
      }, 6000)
    }
  }, [showWarningAlert]);


  const handleClick = async () => {
    if (!newName) {
      setShowWarningAlert(true);
      return;
    }

    if (currentUser) {
      await updateProfile(currentUser, { displayName: newName });

      try {
        const response = await fetch("/update-user", {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            user: { ...userDB, name: newName.toLowerCase().trim() }
          }),
        });
        const data = await response.json();
        setUserDB(data.user);

        if (!response.ok) {
          console.error('Erro ao alterar nome no dbsalepage');
        }
      } catch (err) {
        console.error('Erro ao atualizar nome no dbsalepage', err);
      }
      setShowSuccessAlert(true);
      setMessageAlert('Seu nome já foi alterado.');
      setShowNameModal(false);
    }
  }

  return (
    <Dialog
      open={showNameModal}
      onClose={() => setShowNameModal(false)}
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            handleClick();
          },
          sx: { backgroundImage: 'none', width: '100%' },
        },
      }}
    >
      <DialogTitle>Editar nome</DialogTitle>
      <DialogContent
        sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
      >
        <DialogContentText>
          Digite um novo nome de como gostaria de ser chamado.
        </DialogContentText>
        <Box
          sx={{ '& > :not(style)': { m: 1, width: '25ch' } }}
        >
          <TextField
            id="standard-basic"
            label="Novo nome"
            // variant="standard"
            onChange={(e) => setNewName(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ pb: 3, px: 3 }}>
        <Button onClick={() => setShowNameModal(false)}>Cancelar</Button>
        <Button variant="contained" type="submit">
          Continuar
        </Button>
      </DialogActions>
      {showWarningAlert && (
        <WarningAlert
          message="O campo não pode estar vazio!"
        />
      )}
    </Dialog>
  );
}